import React, { useEffect, useRef, useState } from 'react';
import { cn } from './cn';

interface ProgressBarApi {
  start: () => void;
  done: () => void;
  set: (v: number) => void;
}

let api: ProgressBarApi | null = null;
export function getProgress(): ProgressBarApi {
  if (!api) {
    api = { start: () => {}, done: () => {}, set: () => {} };
  }
  return api;
}

/** Top-of-viewport route progress bar. Mount once near the app root. */
export const ProgressBar: React.FC = () => {
  const [value, setValue] = useState(0);
  const [visible, setVisible] = useState(false);
  const fadeTimer = useRef<number | null>(null);

  useEffect(() => {
    const me: ProgressBarApi = {
      start: () => {
        if (fadeTimer.current) { window.clearTimeout(fadeTimer.current); fadeTimer.current = null; }
        setVisible(true);
        setValue(0);
        // ramp 0 -> 90% over 400ms
        requestAnimationFrame(() => setValue(0.9));
      },
      set: (v) => setValue(Math.max(0, Math.min(1, v))),
      done: () => {
        setValue(1);
        fadeTimer.current = window.setTimeout(() => { setVisible(false); setValue(0); }, 200);
      },
    };
    api = me;
    return () => { api = null; };
  }, []);

  return (
    <div
      className={cn(
        'fixed left-0 right-0 top-0 h-[3px] z-[9999] pointer-events-none transition-opacity duration-150',
        visible ? 'opacity-100' : 'opacity-0'
      )}
      aria-hidden
    >
      <div
        className="h-full origin-left transition-[width] duration-400 ease-out-expo"
        style={{
          width: `${value * 100}%`,
          background: 'linear-gradient(90deg, var(--accent-gold), var(--accent-indigo))',
        }}
      />
    </div>
  );
};
